import { render, staticRenderFns } from "./AppRecommendedProducts.vue?vue&type=template&id=71ef0b86&scoped=true"
import script from "./AppRecommendedProducts.vue?vue&type=script&lang=js"
export * from "./AppRecommendedProducts.vue?vue&type=script&lang=js"
import style0 from "./AppRecommendedProducts.vue?vue&type=style&index=0&id=71ef0b86&prod&lang=css"
import style1 from "./AppRecommendedProducts.vue?vue&type=style&index=1&id=71ef0b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef0b86",
  null
  
)

export default component.exports